import { client } from "@/api/client";
import interceptors from "@/api/interceptor";

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function getStore(params) {
	return client.get("store/data", {
		params: params,
	});
}

function getStoreDetail(params) {
	return client.get("store/detail", {
		params: params,
	});
}

function getStoreByInternal(params) {
	return client.get("store/data-by-product-internal", {
		params: params,
	});
}

function getStoreByAddress(params) {
	return client.get("store/detail-address", {
		params: params,
	});
}
function getKurirByToko(params) {
	return client.get("user/transaction/kurir-toko", {
		params: params,
	});
}

export default {
	getStore,
	getStoreDetail,
	getStoreByInternal,
	getStoreByAddress,
	getKurirByToko
};